import { environment } from '@environments/environment';


export function deepGet (obj: any, props: any, defaultValue: any) {
  if (obj === undefined || obj === null) {
    return defaultValue;
  }
  if (props.length === 0) {
    return obj;
  }
  var foundSoFar = obj[props[0]];
  var remainingProps = props.slice(1);
  return deepGet(foundSoFar, remainingProps, defaultValue);
}


export function safeJsonArray(data: any): any{
  let parsed = [];
  try {
    parsed = JSON.parse(data);
  }
  catch (e) {
    parsed = [];
  }
  return parsed;
}
export function safeJsonObject(data: any): any{
  let parsed = {};
  try {
    parsed = JSON.parse(data);
  }
  catch (e) {
    parsed = {};
  }
  return parsed;
}

// FCSC hosts StemeXe on its own domain (e.g. strstg.fcsc.gov.ae), so documents must be
// generated/opened from that domain instead of the SaaS webLink baked into the build
// Anchored to the FCSC domain so look-alikes such as fcsc.evil.com are rejected
const FCSC_HOST = /(^|\.)fcsc\.gov\.ae$/i;

export function isFcscDomain(): boolean {
  return FCSC_HOST.test(window.location.hostname);
}

export function plannexeDocumentWebLink(): string {
  return isFcscDomain() ? window.location.origin : environment.plannexe.webLink;
}

// The /pdfs page is rendered headless (no session), so it can't resolve the tenant's addon BaseUrl itself.
// On FCSC the API host is passed along as ?api=, kept in sync by PlannexeAppService.setBaseUrl()
let documentApiBaseUrl = '';

export function setPlannexeDocumentApiBaseUrl(url: string): void {
  documentApiBaseUrl = url || '';
}

export function plannexeDocumentApiParams(): { api?: string } {
  return isFcscDomain() && documentApiBaseUrl ? { api: documentApiBaseUrl } : {};
}

export function plannexeDocumentApiQuery(): string {
  const params = plannexeDocumentApiParams();
  return params.api ? '&api=' + encodeURIComponent(params.api) : '';
}

// Only an https FCSC host is accepted, so a crafted link can't send the bypass token elsewhere
export function trustedPlannexeDocumentApiBaseUrl(api: string): string {
  if (!api || !isFcscDomain()) {
    return '';
  }
  try {
    const url = new URL(api);
    return url.protocol === 'https:' && FCSC_HOST.test(url.hostname) ? api.replace(/\/+$/, '') : '';
  } catch (e) {
    return '';
  }
}
